import React from 'react';
import './Foodstuffs.less';
import * as api from 'util/api.js';
import { Switch, Route, Redirect } from 'react-router-dom';
import FoodstuffsTable from './FoodstuffsTable/FoodstuffsTable';
import FoodstuffsSkuSapTable from './FoodstuffsSkuSapTable/FoodstuffsSkuSapTable';

const Foodstuffs = () => (
  <Switch>
    <Route
      exact
      path="/dashboard/foodstuffs/both-islands"
      component={FoodstuffsSkuSapTable}
    />
    {Object.values(api.FOODSTUFFS_REGIONS).map((region) => (
      <Route
        key={region}
        exact
        path={`/dashboard/foodstuffs/${region}`}
        render={() => <FoodstuffsTable region={region} />}
      />
    ))}
    <Redirect to="/dashboard/foodstuffs/north-island" />
  </Switch>
);

export default Foodstuffs;
